<template>
    <div>
        <SubscriptionAlert
            origin="modal"
            @close="showModalSubscription = $event"
            :show="showModalSubscription"
            plan=""
        />
        <Desktop
            @change-profile="$emit('change-profile')"
            @push-route="pushRoute"
            @openSubscriptionAlertModal="openSubscriptionAlertModal"
            v-if="!isMobile"
        />
        <Mobile
            @change-profile="$emit('change-profile')"
            @push-route="pushRoute"
            :show="show"
            @show="show = !show"
            @openSubscriptionAlertModal="openSubscriptionAlertModal"
            v-else
        />
    </div>
</template>

<script>
import Desktop from '@/layouts/header/supplier/guest/desktop.vue';
import Mobile from '@/layouts/header/supplier/guest/mobile.vue';
import SubscriptionAlert from '@/components/modal/subscription-alert/';
export default {
    components: { Mobile, Desktop, SubscriptionAlert },
    name: 'HeaderSupplierGuest',
    data() {
        return {
            isMobile: '',
            show: false,
            showModalSubscription: false
        };
    },
    methods: {
        pushRoute(objectUrl) {
            if (objectUrl.solo) {
                window.open(objectUrl.url, '_blank');
            } else if (objectUrl.url && this.$route.name != objectUrl.url) {
                this.$router.push({ name: objectUrl.url });
            }
            this.show = false;
        },
        openSubscriptionAlertModal() {
            this.showModalSubscription = true;
        }
    },
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 1205;
        });
        vue.isMobile = window.innerWidth <= 1205;
    }
};
</script>
